import { render, staticRenderFns } from "./StoreSelection.vue?vue&type=template&id=c0fa45b6&scoped=true"
import script from "./StoreSelection.vue?vue&type=script&lang=js"
export * from "./StoreSelection.vue?vue&type=script&lang=js"
import style0 from "./StoreSelection.vue?vue&type=style&index=0&id=c0fa45b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fa45b6",
  null
  
)

export default component.exports